/**
 * BasicInfoTab (wandering profile) — read-only details with Edit action.
 *
 * Single section showing the V1-supported fields. Edit + Unassign live in
 * the section header for parity with sibling profile pages; Delete is a
 * lifecycle action on the page header (matches user-profile pattern).
 */

import { Link } from 'react-router-dom';

const BasicInfoTab = ({
  deviceName,
  description,
  serialNum,
  modelName,
  residentId,
  residentName,
  isActive,
  editRights,
  onEdit,
  onUnassign,
}) => {
  const isAssigned = !!residentId && !!Number(isActive);

  return (
    <div className="pp-section">
      <div className="pp-section__header">
        <h3 className="pp-section__title">Device Details</h3>
        {editRights ? (
          <div className="pp-section__actions">
            <button type="button" className="dp-btn dp-btn--secondary dp-btn--sm" onClick={onEdit}>
              ✎ Edit
            </button>
            {isAssigned ? (
              <button type="button" className="dp-btn dp-btn--danger dp-btn--sm" onClick={onUnassign}>
                Unassign
              </button>
            ) : null}
          </div>
        ) : null}
      </div>

      <div className="pp-section__body">
        <div className="pp-field-grid">
          <div className="pp-field">
            <span className="pp-field__label">Device Name</span>
            <span className="pp-field__value">{deviceName || '—'}</span>
          </div>

          <div className="pp-field">
            <span className="pp-field__label">Description</span>
            <span className="pp-field__value">{description || '—'}</span>
          </div>

          <div className="pp-field">
            <span className="pp-field__label">Badge Number</span>
            <span className="pp-field__value">{serialNum || '—'}</span>
          </div>

          <div className="pp-field">
            <span className="pp-field__label">Model</span>
            <span className="pp-field__value">{modelName || '—'}</span>
          </div>

          <div className="pp-field">
            <span className="pp-field__label">Assigned Resident</span>
            <span className="pp-field__value">
              {isAssigned ? (
                <Link to={`/profiles/resident/${residentId}`} className="wp-assigned-chip">
                  {residentName || `Resident ${residentId}`}
                </Link>
              ) : (
                <span className="wp-unassigned-text">Unassigned</span>
              )}
            </span>
          </div>

          <div className="pp-field">
            <span className="pp-field__label">Status</span>
            <span className="pp-field__value">
              <span className={`dp-status ${Number(isActive) ? 'dp-status--active' : 'dp-status--inactive'}`}>
                <span className="dp-status__dot" aria-hidden="true" />
                {Number(isActive) ? 'Active' : 'Inactive'}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
